import { MutationTree } from "vuex";
import * as Msal from "msal";
import {
    LOGIN,
    LOGOUT,
    GET_APPLICATION_VERSION,
    GET_USER,
    GET_ADMIN_USERS,
    GET_VIP_USERS,
    SET_BLOB_SETTINGS,
    SET_LOADED,
} from "./mutations-types";
import { IAppState } from "./state";
import { IUser, IAzureBlobSettings } from "@/models";

export const mutations: MutationTree<IAppState> = {

    [LOGIN](state, payload: Msal.Account): void {
        // Should already be done in the initial state.
        state.userAccount = payload;
    },

    [LOGOUT](state): void {
        state.userAccount = null;
    },

    [GET_APPLICATION_VERSION](state, payload: string): void {
        state.applicationVersion = payload;
    },

    [GET_USER](state, payload: IUser): void {
        state.user = payload;
    },

    [GET_ADMIN_USERS](state, payload: IUser[]): void {
        state.adminUsers = payload;
    },

    [GET_VIP_USERS](state, payload: IUser[]): void {
        state.vipUsers = payload;
    },

    [SET_BLOB_SETTINGS](state, payload: IAzureBlobSettings): void {
        state.blobSettings = payload;
    },
};
